import React from "react"

import { CopyButton } from "@/components/CopyButton"
import { cn } from "@/lib/utils"
import { AuditActor } from "@/utils/auditActor"

const AuditActorField: React.FC<{ label: string; value: string | null }> = ({ label, value }) => (
  <div className="flex min-w-0 items-center gap-2 py-1">
    <dt className="w-20 shrink-0 text-[11px] font-medium uppercase tracking-wide text-palette-jungleGreen500">
      {label}
    </dt>
    <dd
      className={cn(
        "min-w-0 flex-1 break-all font-mono text-xs",
        value ? "text-palette-jungleGreen900" : "italic text-palette-jungleGreen500",
      )}
    >
      {value ?? "Empty"}
    </dd>
    {value ? <CopyButton value={value} label={label.toLowerCase()} /> : <span className="w-6" />}
  </div>
)

// The raw columns, so whoever is investigating can search for them elsewhere.
export const AuditActorDetails: React.FC<{ entry: AuditActor; className?: string }> = ({
  entry,
  className,
}) => (
  <dl
    className={cn(
      "divide-y divide-palette-jungleGreen100 rounded-md border border-palette-jungleGreen200 bg-palette-jungleGreen000 px-2.5 py-1",
      className,
    )}
  >
    <AuditActorField label="Actor" value={entry.actor?.trim() || null} />
    <AuditActorField label="User ID" value={entry.actor_user_id} />
    <AuditActorField label="Kind" value={entry.actor_kind} />
  </dl>
)
